import React from "react";
import "../Actividad.css";

function ActividadInfoForm({ actividad }) {
  if (!actividad) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="actividad-info">
      <h5>Información General</h5>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Fecha de Inicio:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.f_inicio ? actividad.f_inicio : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Fecha de Término:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.f_termino ? actividad.f_termino : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Formato:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.formato ? actividad.formato : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Capacitación:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.horas_c ? `${actividad.horas_c} hrs` : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Talleres:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.horas_t ? `${actividad.horas_t} hrs` : "-----"}
        </div>
      </div>

      <div className="actividad-info-row">
        <div className="actividad-info-label">
          <strong>Act. Extraprogramáticas:</strong>
        </div>
        <div className="actividad-info-data">
          {actividad.horas_e ? `${actividad.horas_e} hrs` : "-----"}
        </div>
      </div>
    </div>
  );
}

export default ActividadInfoForm;
